<template>
  <div class="card">
    <img src="@/assets/images/award/cardBg.png" class="bg" />
    <img src="@/assets/images/award/medal.png" class="medal" />
    <div class="cardBox">
      <div class="topBox">
        <div class="situation">
          <p class="title">{{ lang('本月达成情况') }}</p>
          <p class="date">{{ getPreviousDate(new Date()) }}</p>
        </div>
        <div class="award">
          <div class="awardBox">
            <div class="awardName" @click="() => (show = !show)">
              <p>{{ lang('奖励(积分)') }}</p>
              <van-icon name="info-o" :size="16" />
            </div>
            <p class="awardNum">{{ reward || '0' }}</p>
          </div>
          <div class="collect">
            <div v-for="(item, i) in list" :key="i" class="collectBox">
              <p>{{ item.name }}</p>
              <p class="collectNum">{{ item.num }}</p>
            </div>
          </div>
        </div>
      </div>
      <div class="bottom">
        <div ref="fullElement" class="deliver">
          <img
            :style="{ left: position }"
            src="@/assets/images/award/deliver.png"
          />
          <div
            ref="myPopElement"
            class="pop"
            :class="[popDirection === 0 ? 'left' : 'right']"
            :style="{ left: popPosition }"
          >
            {{ lang('增长量') }}: {{ increaseNum }}
          </div>
        </div>
        <div class="progress">
          <div class="empty"></div>
          <div
            ref="myElement"
            class="filled"
            :style="{ width: progress }"
          ></div>
          <div class="scar">
            <p v-for="(item, i) in scarList" :key="i">{{ item }}</p>
          </div>
        </div>
      </div>
    </div>
    <van-action-sheet v-model:show="show">
      <rule @confirm="confirm()" />
    </van-action-sheet>
  </div>
</template>
<script lang="ts" setup>
import { nextTick, ref, watch } from 'vue'
import lang from '@/langs'
import Rule from '@/views/award/component/rule.vue'
import { getInspireResp } from '@/model/award/award'
import { getPreviousDate } from '@core/utils/aboutDate'

const props = defineProps<{ info: getInspireResp }>()
const scarList = [0, 150, 300, 450]
const progress = ref('0%')
const myElement = ref(null) // 绑定元素的 ref
const myPopElement = ref(null) // 绑定元素的 ref
const fullElement = ref(null) // 绑定元素的 ref
const popDirection = ref(0) //0尖尖往右 1尖尖往左
const position = ref('0')
const popPosition = ref('0px')
const show = ref(false)
const infoValue = ref<getInspireResp>()
const increaseNum = ref(0)
const reward = ref('0')
const initialList = () => [
  { name: lang('上月揽收'), num: infoValue.value?.lastMonthNum || '0' },
  { name: lang('本月揽收'), num: infoValue.value?.monthNum || '0' }
]
const list = ref(initialList())
watch(
  () => props.info,
  (value) => {
    infoValue.value = value
    list.value = initialList()
    increaseNum.value = value?.increaseNum || 0
    reward.value = value?.reward || '0'
    if (increaseNum.value !== 0 && increaseNum.value >= 450) {
      progress.value = '100%'
    } else if (increaseNum.value && increaseNum.value < 450) {
      progress.value = Math.floor((increaseNum.value / 450) * 100) + '%'
    }
    nextTick(() => {
      getElementWidth()
    })
  },
  {
    immediate: true
  }
)
const confirm = () => {
  show.value = false
}
const getElementWidth = () => {
  if (myElement.value) {
    const offsetWidth = myElement.value?.offsetWidth
    if (offsetWidth && offsetWidth >= 60) {
      position.value = offsetWidth - 60 + 'px'
    } else {
      position.value = '0px'
    }
  }
  if (myPopElement.value && fullElement.value && myElement.value) {
    const pop = myPopElement.value?.offsetWidth || 0 //小气泡宽度
    const full = fullElement.value?.offsetWidth || 0
    let progress = myElement.value?.offsetWidth || 0 //进度条宽度
    const differ = full - progress + 10
    if (differ <= pop) {
      popDirection.value = 1
      popPosition.value = progress - (60 + pop) + 'px'
    } else {
      popDirection.value = 0
      if (progress > pop) {
        popPosition.value = progress + 'px'
      } else {
        popPosition.value = 60 + 'px'
      }
    }
  }
}
</script>

<style scoped lang="less">
.card {
  margin: 11px;
  position: relative;
  .bg {
    position: absolute;
    width: 100%;
    z-index: 0;
    height: 100%;
  }
  .medal {
    position: absolute;
    z-index: 0;
    width: 100px;
    right: 12px;
  }
  .cardBox {
    padding: 20px 17px;
    padding-bottom: 14px;
    position: relative;
    .topBox {
      position: relative;
      .situation {
        display: flex;
        flex-direction: row;
        justify-content: space-between;
        .title {
          font-size: 17px;
          font-weight: 500;
          color: rgba(0, 0, 0, 1);
        }
        .date {
          font-size: 10px;
          font-weight: 500;
          color: rgba(0, 0, 0, 1);
        }
      }
      .award {
        display: flex;
        flex-direction: row;
        margin-top: 12px;
        align-items: flex-end;
        .awardBox {
          .awardName {
            font-size: 13px;
            font-weight: 500;
            display: flex;
            flex-direction: row;
            align-items: center;
            color: rgba(0, 0, 0, 1);
            > p {
              margin-right: 7px;
            }
          }
          .awardNum {
            margin-top: 6px;
            font-size: 36px;
            font-weight: 500;
            color: rgba(75, 48, 13, 1);
          }
        }
        .collect {
          flex: 1;
          display: flex;
          flex-direction: row;
          justify-content: space-evenly;
          .collectBox {
            text-align: center;
            > p {
              font-size: 13px;
              font-weight: 400;
              color: rgba(51, 51, 51, 1);
            }
            .collectNum {
              margin-top: 3px;
              font-size: 15px;
              font-weight: 500;
              color: rgba(75, 48, 13, 1);
            }
          }
        }
      }
    }
    .bottom {
      margin-top: 14px;
      .deliver {
        position: relative;
        > img {
          width: 60px;
          //aspect-ratio: 160/137;
          position: relative;
          z-index: 9;
        }
        .pop {
          width: auto;
          background: linear-gradient(
            90deg,
            rgba(255, 162, 131, 1) 0%,
            rgba(234, 25, 38, 1) 100%
          );
          position: absolute;
          top: 0;
          padding: 3px;
          font-size: 10px;
          color: #fff;
        }
        .left {
          border-radius: 10px 10px 10px 0px;
        }
        .right {
          border-radius: 10px 10px 0px 10px;
        }
      }
      .progress {
        position: relative;
        .empty {
          background: #fff;
          height: 4px;
          border-radius: 2px;
        }
        .filled {
          position: absolute;
          top: 0;
          z-index: 9;
          height: 4px;
          border-radius: 2px;
          background: linear-gradient(
            90deg,
            rgba(255, 162, 131, 1) 0%,
            rgba(234, 25, 38, 1) 100%
          );
        }
        .scar {
          display: flex;
          flex-direction: row;
          justify-content: space-between;
          margin-top: 6px;
        }
      }
    }
  }
}
</style>
